/*
 * Routinae - one-click "add the whole routine".
 *
 * Progressive enhancement ONLY. The element wraps a real
 *   <form method="post" action="/cart/add">
 * carrying items[n][id] / items[n][quantity] inputs. With JavaScript off, or
 * if anything below throws before preventDefault(), the browser submits that
 * form natively and Shopify lands the customer on the cart page with every
 * step added. That path is the contract; this file only makes it nicer.
 *
 * Deliberately NOT reusing Dawn's <product-form>: that element assumes a
 * single `id` field, reads formData.get('id') to publish cart events, and
 * would publish undefined for a multi-line add.
 *
 * GOTCHAS.md #21 applies: there is no `required` input in this form and no
 * client-side gate, because a gate here would be bypassable and therefore
 * theatre. If a routine ever needs an acknowledgement, it goes on the product
 * page where the server can see it.
 */
if (!customElements.get('routine-add')) {
  customElements.define(
    'routine-add',
    class RoutineAdd extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        if (!this.form || !this.button) return;
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (document.querySelector('cart-drawer')) {
          this.button.setAttribute('aria-haspopup', 'dialog');
        }
      }

      onSubmit(event) {
        // Without a cart drawer or notification there is nothing to render into,
        // so let the native submit happen and land on /cart. Same for a browser
        // with no fetch.
        if (!this.cart || typeof window.fetch !== 'function' || typeof routes === 'undefined') {
          return;
        }

        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');

        const formData = new FormData(this.form);
        formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            // A multi-line add that fails returns { status, message, description }
            // and adds NOTHING. Do not pretend otherwise: hand the customer back
            // to the native form so Shopify can show them the real reason.
            if (response.status) {
              this.form.submit();
              return;
            }
            this.cart.renderContents(response);
          })
          .catch(() => {
            this.form.submit();
          })
          .finally(() => {
            this.button.removeAttribute('aria-disabled');
            this.button.classList.remove('loading');
          });
      }
    }
  );
}
